

export const filteruserPerGrup = (grupSelected, arrayData, usersByGroups, groups) => {
    // const start = performance.now();
    let alumns = []
    let arrayDataContest = arrayData
    if (grupSelected === "all") {
        alumns = usersByGroups.flatMap(grup =>
            grup.students.map(student => ({
                ...student, // Copia todas las propiedades de cada estudiante
                groupName: grup.group // Agrega la propiedad `groupName` con el valor de `grup.name`
            }))
        );

    }
    else {
        const group = groups.find(item => item._id === grupSelected);
        alumns = usersByGroups.flatMap(grup =>
            grup.students.map(student => ({
                ...student, // Copia todas las propiedades de cada estudiante
                groupName: grup.group // Agrega la propiedad `groupName` con el valor de `grup.name`
            }))
        )
        alumns = alumns.filter(alumn => alumn.learningGroupId === group._id)
        arrayDataContest = arrayData.filter(alumn => alumn.grupo === group.name)

    }
    let uniqueKey = 0;
    const combined = alumns.map(alumn => {
        // const match = arrayDataContest.find(data => data.matricula === alumn.userId);
        const match = [...arrayDataContest].reverse().find(data => data.matricula === alumn.userId);
        const result = match || alumn;
        return {
            ...result,
            Nombre: match ? match.Nombre : alumn.name,
            matricula: match ? match.matricula : alumn.userId,
            _idUser: match ? match._idUser : alumn._id,
            grupo: match ? match.grupo : alumn.groupName,
            Fecha_y_hora: match ? match.Fecha_y_hora : "0000-00-00T00:12:45.814Z",
            key: `key-${uniqueKey++}`
        };
    });
    combined.sort((a, b) => {
        if (a.puntaje && !b.puntaje) {
            return -1; // a va antes que b
        } else if (!a.puntaje && b.puntaje) {
            return 1; // b va antes que a
        } else {
            return 0; // no cambia el orden relativo
        }
    });
    // console.log(combined.filter(r => r.matricula === "154612"))
    // const end = performance.now();
    // console.log(`La función tardó ${end - start} ms.`);
    // console.log("***********")
    // console.log(combined)
    return (combined);

}